import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withProps from 'recompose/withProps';
import { getActiveCanvasDrawer, updateActiveCanvasDrawer } from './duck';
import CanvasDrawer from './CanvasDrawers';
import withQueryParams from '../../hocs/withQueryParams';
import withCart from '../../hocs/withCart';
import withProduct from '../../hocs/withProduct';
import withCountry from '../../hocs/withCountry';
import { shouldRedirectToOptions, buildOrderUrl, flagUneditableDrawer, getNextAvailableDrawerId } from './helpers';
import { trackSaveCanvasChanges } from '../../../analytics/category/cart';
import { getProductBySlug } from 'src/common/config/product';
import { getItems } from '../../../store/selectors/cart';
import { updateOrderItem } from '../../../facades/eagle/user';
import { addFlashMessageError } from '../FlashMessages/duck';
import buildProductUrl from '../../utils/buildProductUrl';
import omitBy from 'lodash/omitBy';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

const enhance = compose(
  withQueryParams,
  connect(
    (state) => ({
      activeDrawer: getActiveCanvasDrawer(state),
      cartItems: getItems(state),
    }),
    dispatch => ({
      handleToggleDrawer: key => dispatch(updateActiveCanvasDrawer(key)),
      flashError: error => dispatch(addFlashMessageError(error)),
    }),
  ),
  withCart,
  withProps(props => {
    const prismicProduct = get(props, 'prismicProduct', {});
    const saveForLaterProductSpecificData = omitBy(prismicProduct.saveForLater, (value) => {
      return isNil(value) || isEmpty(value);
    });
    const saveForLaterGlobalContentData = get(props, 'model.prismicGlobalContentModel.saveForLater', {});
    const saveForLaterData = { ...saveForLaterGlobalContentData, ...saveForLaterProductSpecificData };
    const adventurers = props.productCustomisation.characters;
    let adventurersNames = [props.productCustomisation.name];

    if (adventurers) {
      adventurersNames = adventurers.map(adventurer => adventurer.name);
    }

    /* eslint-disable eqeqeq */
    // Check whether the value in the url query params matches the id of an actual cart item
    // this is to avoid hiding drawers if the id is faked (from the url params for example)
    const isCartItem = props.cartItems.some(item => item.id == props.match.params.itemId);
    /* eslint-enable eqeqeq */
    return {
      isCartItem,
      drawers: flagUneditableDrawer(isCartItem, !!props.match.params.itemId, props.drawers),
      cartPending: props.cart.status.request.queue.length > 0,
      isAllDrawersComplete: props.completedDrawersMap.required.every(drawer =>
        props.completedDrawersMap.complete.includes(drawer),
      ),
      saveForLaterData,
      saveForLaterCtaIconGlobalContent: saveForLaterData.saveForLaterCtaIcon,
      saveForLaterCtaTextGlobalContent: saveForLaterData.saveForLaterCtaText,
      saveForLateCtaStyle: saveForLaterData.ctaStyle,
      saveForLaterCtaBackgroundColor: saveForLaterData.ctaBackgroundColor,
      saveForLaterCtaTextColor: saveForLaterData.ctaTextColor,
      errorMessages: props.model.prismicGlobalContentModel.error,
      canonicalUrl: props.model.canonicalUrl,
      locale: props.model.countryModel.locale,
      adventurersNames,
    };
  }),
  withProduct,
  withCountry,
  withHandlers({
    onSubmitDrawers: props => () => {
      const itemId = props.match.params.itemId;
      let optionsPage = { type: 'options', query: { addonPage: 1 } };

      if (itemId) {
        if (props.isCartItem) {
          shouldRedirectToOptions(props)
            .then(async (hasOptions) => {
              const slug = props.match.params.productSlug;
              trackSaveCanvasChanges(getProductBySlug(slug).sku);
              if (hasOptions) {
                optionsPage.itemId = itemId;
                window.location = buildProductUrl(props, optionsPage);
              } else {
                await props.cart.edit(itemId);
                window.location = buildProductUrl(props, { type: 'cart' });
              }
            });
        } else {
          const payload = { item: { id: itemId, customisations: props.productCustomisation } };
          // Editing a post-purchase item
          updateOrderItem(payload)
            .then((res) => {
              window.location = res.headers.admin_redirect_path || buildOrderUrl(props);
            })
            .catch(err => {
              const errors = err.details.errors;
              errors.forEach(error => props.flashError(error.detail));
            });
        }
      } else {
        shouldRedirectToOptions(props)
          .then(res => {
            if (res) {
              window.location = buildProductUrl(props, optionsPage);
            } else {
              props.cart.add();
            }
          });
      }
    },
    onContinueDrawers: props => () => {
      const nextDrawer = getNextAvailableDrawerId(props.completedDrawersMap.incomplete);

      if (nextDrawer) {
        props.handleToggleDrawer(nextDrawer);
      }
    },
  }),
);

export default enhance(CanvasDrawer);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CanvasDrawers/index.js